import { render } from "./ProductDelete.vue?vue&type=template&id=7cd297ec&ts=true"
import script from "./ProductDelete.vue?vue&type=script&lang=ts"
export * from "./ProductDelete.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__